module.exports = __webpack_public_path__ + "static/media/sucesso.779b639f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/sucesso.svg
// module id = 2755
// module chunks = 0